import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('RewardClaim').create(({ theme }) => ({
  root: {
    zIndex: 999,
    position: 'relative',
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundColor: 'rgb(29, 30, 34)',
    transition: 'opacity 0.5s ease-in-out',
    '&[data-isvideoended="true"]': {
      opacity: '1',
      pointerEvents: 'auto',
    },
    '&[data-isvideoended="false"]': {
      opacity: '0',
      pointerEvents: 'none',
    },

    '&[data-rarity="Legendary"]': {
      '::before': {
        backgroundColor: theme.colors.borders.legendary,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        top: '-10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(135px)',
      },

      '::after': {
        backgroundColor: theme.colors.borders.legendary,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        bottom: '-55%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(125px)',
      },
    },

    '&[data-rarity="Epic"]': {
      '::before': {
        backgroundColor: theme.colors.borders.epic,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        top: '-10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(135px)',
      },

      '::after': {
        backgroundColor: theme.colors.borders.epic,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        bottom: '-55%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(125px)',
      },
    },

    '&[data-rarity="Rare"]': {
      '::before': {
        backgroundColor: theme.colors.borders.rare,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        top: '-10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(135px)',
      },

      '::after': {
        backgroundColor: theme.colors.borders.rare,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        bottom: '-55%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(125px)',
      },
    },
    '&[data-isps5="true"]': {
      '::before': {
        backgroundColor: 'rgba(245, 238, 78, 0.5)',
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        aspectRatio: '1/1',
        top: '-10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(135px)',
      },

      '::after': {
        backgroundColor: 'rgba(245, 238, 78, 0.5)',
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        aspectRatio: '1/1',
        bottom: '-55%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(125px)',
      },
    },
  },

  headingWrapper: {
    display: 'flex',
    width: '100%',
    height: '60px',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '12',
  },

  rewardInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',

    '&[data-isunique="true"]': {
      height: '76vh',
    },
  },

  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',

    '&[data-isunique="true"]': {
      bottom: '20px',
    },
  },

  amoutOfPointsWrapper: {
    display: 'flex',
    width: 'fit-content',
    minHeight: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    zIndex: 9,
  },

  img: {
    position: 'relative',
    maxWidth: '360px',
    width: '100%',
    justifySelf: 'center',
  },

  heading: {
    fontFamily: 'Inter',
    fontWeight: 450,
    fontSize: '20px',
    lineHeight: '24px',
    color: theme.colors.text.primary,
    textAlign: 'center',
  },

  textWrapper: {
    width: '100%',
    position: 'absolute',
    zIndex: '15',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: '1',
  },

  amountOfPoints: {
    fontFamily: 'Space Grotesk, Inter',
    fontWeight: 600,
    fontSize: '30px',
    lineHeight: '30px',
    letterSpacing: '-0.02em',
    color: theme.colors.text.primary,
  },

  congrats: {
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,
    fontWeight: 350,
    color: theme.colors.text.secondary,
    display: 'block',
    maxWidth: '342px',
  },

  uniqueGiftText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: theme.sizes.texts.fontSize.xl,
    lineHeight: '40px',
    textAlign: 'center',
    color: theme.colors.text.primary,
  },

  rarityText: {
    fontFamily: 'Inter',
    fontWeight: 550,
    fontSize: '17px',
    lineHeight: '24px',
    color: theme.colors.text.link,
    textAlign: 'center',

    '&[data-textcolor="Legendary"]': {
      color: theme.colors.borders.legendary,
    },

    '&[data-textcolor="Epic"]': {
      color: theme.colors.borders.epic,
    },

    '&[data-textcolor="Rare"]': {
      color: theme.colors.borders.rare,
    },

    '&[data-textcolor="Uncommon"]': {
      color: theme.colors.borders.uncommon,
    },

    '&[data-textcolor="Common"]': {
      color: theme.colors.text.primary,
    },
  },

  buttonsWrapper: {
    padding: '28px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '90%',
    gap: '8px',
    marginTop: 'auto',
    position: 'absolute',
    bottom: '0',
    zIndex: '12',
  },

  shareButton: {
    height: '52px',
    flexGrow: 1,
    padding: '14px 24px',
    display: 'flex',
    gap: '12px',
    background: 'rgba(255, 255, 255, 0.16)',
  },

  claimButton: {
    height: '52px',
    padding: '14px 24px',
    '&[data-free="true"]': {
      width: '100%',
    },
  },

  videoWrapper: {
    zIndex: 998,

    video: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: 0,
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: 0,
      transition: 'opacity 0.322s ease-in-out',
      '&[data-appeared="true"]': {
        opacity: '1',
      },
    },
  },
}))
